import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useHMACQuery = createQueryHook(ShopRendererApiClient.getHMAC, {
  queryKey: ['hmac'],
})
